// types
export const actionTypes = {
  SET_CACHE: "SET_CACHE",
  RESTORE_CACHE: "RESTORE_CACHE",
} as const;

export interface CacheItem<T = any> {
  data: T;
  expiry: number;
  lastFetched: number;
}

export interface CacheState {
  [key: string]: CacheItem;
}

type Action =
  | { type: typeof actionTypes.SET_CACHE; payload: { key: string; cacheItem: CacheItem } }
  | { type: typeof actionTypes.RESTORE_CACHE; payload: CacheState };

// initial state
const initialState: CacheState = {};

// action creators
const actions = {
  setCache: (key: string, cacheItem: CacheItem) => ({
    type: actionTypes.SET_CACHE,
    payload: { key, cacheItem },
  }),

  restoreCache: (cache: CacheState) => ({
    type: actionTypes.RESTORE_CACHE,
    payload: cache,
  }),
};

// reducer
const reducer = (state: CacheState = initialState, action: Action): CacheState => {
  switch (action.type) {
    case actionTypes.SET_CACHE: {
      if (!state) return state;

      const { key, cacheItem } = action.payload;
      const newCache = { ...state };
      newCache[key] = cacheItem;
      return newCache;
    }

    case actionTypes.RESTORE_CACHE: {
      if (!state) return state;

      const newCache = action.payload;
      return newCache;
    }

    default:
      return state;
  }
};

export { reducer, actions };
